import React from "react";
import { useEffect, useState } from "react";

import CoachListTable from "../../components/AdminCoachPanel/coaches/CoachListTable/CoachListTable";
import { ToastContainer, toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { AddBadge, AddCoach, GetAllCoaches, GetCoachDetail, UpdateCoach } from "../../api/AdminCoachPanel/coachApis";
import SearchBar from "../../components/AdminCoachPanel/coaches/SearchBar/SearchBar";
import FilterChips from "../../components/AdminCoachPanel/coaches/FilterChips/FilterChips";
import "./Coaches.css";
import PageHeader from "../../components/AdminCoachPanel/coaches/PageHeader/PageHeader";
import CardSection from "../../components/AdminCoachPanel/coaches/CardSection/CardSection";
import Pagination from "../../components/AdminCoachPanel/coaches/Pagination/Pagination";
import CoachModal from "../../components/AdminCoachPanel/coaches/CoachModal/CoachModal";
import SideBar from "../../components/SideBar";
import { useMediaQuery } from "react-responsive";
import ResponseStatus from "../../enums/ResponseStatus";
import { Components } from "../../assets/Dimensions";


export default function Coaches() {
    const [nav, setNav] = useState(false);
  const [coaches, setCoaches] = useState([]);
  const [allCoaches, setAllCoaches] = useState([]); // For filtering later
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState("");
  const [seatsOnly, setSeatsOnly] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCoach, setSelectedCoach] = useState(null);
  const [modalMode, setModalMode] = useState("edit"); // or "create"
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 700px)" });
  const user = JSON.parse(localStorage.getItem("user"));
  const userAdminToken = sessionStorage.getItem("jwtP");
  const history = useHistory();
  // const [sortConfig, setSortConfig] = useState([{ key: null, direction: "asc" }]);
  const [sortConfig, setSortConfig] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const selectedIndex = selectedCoach === null ? -1 : coaches.findIndex(
    coach => coach.Id === selectedCoach.Id
  );
  const order = selectedIndex !== -1 ? selectedIndex + 1 : null;
  const total = coaches.length;


  const getCoachList = async () => {
    try {
      setLoader(true);

      const res = await GetAllCoaches(user.Token);

      if (res.data.ResponseStatus === 1) {
        const response = res.data.ResponseData;


        // Save raw
        setAllCoaches(response);

        // Initial table data
        setCoaches(response);
      } else {
        toast.error("Koç listesi alınamadı.");
        history.push("/dashboard");
      }
    } catch (error) {
      console.error("Error fetching coaches:", error);
      toast.error("Bir hata oluştu, lütfen tekrar deneyiniz.");
    } finally {
      setLoader(false);
    }
  };

  const resolveBadges = async (payload) => {
    const allBadges = payload.CoachDetail.Badges || [];
  
    const newBadges = allBadges.filter(b => b.isNew);
    const existingBadges = allBadges.filter(b => !b.isNew);
  
    const createdBadges = [];
  
    for (const badge of newBadges) {
      const res = await AddBadge(
        user.Token,
        { Name: badge.Name }
      );

  
      if (res.data.ResponseStatus !== ResponseStatus.Success) {
        throw new Error("Badge eklenemedi");
      }
  
      // 🔥 MAP RESPONSE TO EXPECTED SHAPE
      createdBadges.push({
        Id: res.data.ResponseData.BadgeId,
        Name: badge.Name,
      });
    }
  
    return existingBadges.concat(createdBadges);
  };
  
  


  const addNewCoach = async (payload) => {
    setLoader(true);
    try {
      const finalBadges = await resolveBadges(payload);
  
      const finalPayload = {
        ...payload,
        CoachDetail: {
          ...payload.CoachDetail,
          Badges: finalBadges,
        },
      };
  
      const res = await AddCoach(user.Token, finalPayload);
  
      if (res.ResponseStatus === ResponseStatus.Success) {
        toast.success("Koç Başarıyla eklendi");
      }
    } catch (error) {
      console.error(error);
      toast.error("Koç eklenirken hata oluştu");
    } finally {
      setLoader(false);
      setIsModalOpen(false);
      getCoachList();
    }
  };
  
  const updateCoach = async (payload) => {
    setLoader(true);
    try {
      const finalBadges = await resolveBadges(payload);
  
      const finalPayload = {
        ...payload,
        CoachDetail: {
          ...payload.CoachDetail,
          Badges: finalBadges,
        },
      };
  
      const res = await UpdateCoach(user.Token, finalPayload);
  
      if (res.ResponseStatus === ResponseStatus.Success) {
        toast.success("Koç Başarıyla Güncellendi");
      }
    } catch (error) {
      console.error(error);
      toast.error("Koç güncellenirken hata oluştu");
    } finally {
      setLoader(false);
      setIsModalOpen(false);
      getCoachList();
    }
  };
  

  const CoachDetail = async (id) => {
    try {
      setLoader(true);

      const res = await GetCoachDetail(user.Token,id);

      if (res.data.ResponseStatus === 1) {
        const response = res.data.ResponseData;


        // Save raw
        setSelectedCoach(response);

     
      } else {
        toast.error("Koç  alınamadı.");
        history.push("/dashboard");
      }
    } catch (error) {
      console.error("Error fetching coaches:", error);
      toast.error("Bir hata oluştu, lütfen tekrar deneyiniz.");
    } finally {
      setLoader(false);
    }
  }

  useEffect(() => {
    getCoachList();
  }, []);

  const filtered = allCoaches.filter((c) =>
    c.Name.toLowerCase().includes(search.toLowerCase())
  );

  // Update table whenever search changes
  useEffect(() => {
    setCoaches(filtered);
  }, [search]);



function openEditModal(coach) {
  // setSelectedCoach(coach);
  CoachDetail(coach.Id)
  setModalMode("edit");
  setIsModalOpen(true);
}

function openCreateModal() {
  setSelectedCoach(null);
  setModalMode("create");
  setIsModalOpen(true);
}

function handleSaveCoach(payload,mode) {
  if(mode === 'edit'){
    updateCoach(payload)
  }else{
    addNewCoach(payload)
  }
  

  // call POST or PUT here
  // setIsModalOpen(false);
  // getCoachList(); // re-fetch if desired
}

const  sortData = (data) => {
  if (!sortConfig.key) return data;

  const sorted = [...data].sort((a, b) => {
    let valA = a[sortConfig.key];
    let valB = b[sortConfig.key];

    // Normalize undefined/null
    if (valA == null) valA = "";
    if (valB == null) valB = "";

    // TURKISH STRING SORT
    if (typeof valA === "string" && typeof valB === "string") {
      return sortConfig.direction === "asc"
        ? valA.localeCompare(valB, "tr", { sensitivity: "base" })
        : valB.localeCompare(valA, "tr", { sensitivity: "base" });
    }

    // NUMBER SORT
    if (typeof valA === "number" && typeof valB === "number") {
      return sortConfig.direction === "asc" ? valA - valB : valB - valA;
    }

    // FALLBACK
    return 0;
  });

  return sorted;
}


const pageSize = 10;

const totalPages = Math.ceil(coaches.length / pageSize);

const startIndex = (currentPage - 1) * pageSize;
const endIndex = startIndex + pageSize;

// const sortedCoaches = sortData(coaches);

function turkishSort(a, b) {
  return a.localeCompare(b, "tr", { sensitivity: "base" });
}

let sortedCoaches = [...coaches];

if (sortConfig.length > 0) {
  sortedCoaches.sort((a, b) => {
    for (let rule of [...sortConfig].reverse()) {
      // reverse = last clicked column → highest priority
      const { key, direction } = rule;
      let result = 0;

      switch (key) {
        case "Name":
          result = turkishSort(a.Name || "", b.Name || "");
          break;

        case "Seats":
          result = (a.RemainingSeats || 0) - (b.RemainingSeats || 0);
          break;

        case "Students":
          result = (a.TotalStudents || 0) - (b.TotalStudents || 0);
          break;

        case "Status":
          const weight = (x) => (x === "Active" ? 1 : 2);
          result = weight(a.Status) - weight(b.Status);
          break;

        default:
          break;
      }

      if (result !== 0) {
        return direction === "asc" ? result : -result;
      }
    }

    return 0;
  });
}

const paginatedCoaches = sortedCoaches.slice(startIndex, endIndex);

useEffect(() => {
  setCurrentPage(1);   // reset page when searching
  setCoaches(filtered);
}, [search]);

// function requestSort(key) {
//   let direction = "asc";
//   if (sortConfig.key === key && sortConfig.direction === "asc") {
//     direction = "desc";
//   }
//   setSortConfig({ key, direction });
// }

function requestSort(key) {
  setSortConfig((prev) => {
    const existing = prev.find((s) => s.key === key);

    // 1) If not sorted yet → add ASC
    if (!existing) {
      return [...prev, { key, direction: "asc" }];
    }

    // 2) If ASC → change to DESC
    if (existing.direction === "asc") {
      return prev.map((s) =>
        s.key === key ? { ...s, direction: "desc" } : s
      );
    }

    // 3) If DESC → remove (RESET)
    return prev.filter((s) => s.key !== key);
  });
}




  return (
    <>
    {isTabletOrMobile ? (
        <div>
          <span
            style={{ position: "absolute", top: 10, right: 10 }}
            onClick={() => setNav(!nav)}
          >
            menu
          </span>
          {nav && <SideBar />}
        </div>
      ) : (
        <SideBar />
      )}
      <ToastContainer />
    <div className="coaches-page" style={{paddingLeft: isTabletOrMobile ? 15 : Components.SideBarWidth + 15,}}>
    <div className="coaches-page-container">
      {/* Page heading */}
      <PageHeader
        title="Koç Profil Düzenleme"
        buttonLabel="+ Yeni Koç Ekle"
        onButtonClick={() => openCreateModal()}  // or your logic
      />
<CardSection>
      {/* Search */}
      <div className="card-section-block">
              <div className="coach-filters-container">
          <SearchBar
            value={search}
            onChange={setSearch}
            placeholder="İsme Göre Ara"
          />

          {/* <FilterChips
            seatsOnly={seatsOnly}
            onSeatsToggle={setSeatsOnly}
            onUniversityClick={() => console.log("University filter")}
            onRankClick={() => console.log("Rank filter")}
          /> */}
        </div>

        {/* TABLE */}
        {loader ? (
          <div className="p-8 text-center">Loading...</div>
        ) : (
            <CoachListTable coaches={paginatedCoaches} onEdit={openEditModal} requestSort={requestSort} sortConfig={sortConfig}/>

        )}
      </div>
      <div className="card-section-block">
      <Pagination
  currentPage={currentPage}
  totalPages={totalPages}
  pageSize={pageSize}
  totalItems={coaches.length}
  onPageChange={setCurrentPage}
/>
  </div>
    </CardSection>
    </div>
    <CoachModal
  isOpen={isModalOpen}
  mode={modalMode}
  coach={selectedCoach}
  onClose={() => {setIsModalOpen(false)
    setSelectedCoach(null)}}
    onSave={handleSaveCoach}
    selectedCoachOrder={order}
/>
    </div>
    </>

  );
}
